import { render, staticRenderFns } from "./Bilans.vue?vue&type=template&id=2997b056&"
import script from "./Bilans.vue?vue&type=script&lang=js&"
export * from "./Bilans.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports